import React from "react";
import CreditCardList from "./CreditCardList";
import EntityList from "../EntityList/EntityList";
import FormCreateNewPaymentType from "./CreateNewPaymentType.tsx";

import { PAYMENT_TYPES_NAMES, PAYMENT_TYPES_VALUES } from "../../Common/constants";
import { withProperty } from "../../../../components/property-provider";

function customEntityToListValuesMapper({ entities, currentLocale }) {
  const setTextPaymentType = label =>
    label === PAYMENT_TYPES_NAMES[currentLocale].PAY_NO_PAIN_PROXY
      ? PAYMENT_TYPES_VALUES.tc_garantia_pci
      : label;

  return entities.map(entity => {
    const type = setTextPaymentType(PAYMENT_TYPES_NAMES[currentLocale][entity.type]);
    let title = entity.translations.find(translation => translation.language === currentLocale);
    title = title && title.title;

    return {
      ...entity,
      type,
      title,
    };
  });
}
class PaymentTypesList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      entities: [],
    };
  }

  handleToggle = ({ event, field, entity }) => {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      activeProperty: "active",
    });
  };

  handleDelete = ({ event, entity }) => {
    //If successful fetch the list once again
    //this should belong to the HoC?

    //this should call the api, change the status
    //if successful fetch the list once again and show it
    //if error show error.
    //it should show a loader while updating

    //this behaviour is reusable so it should belong in the HoC

    event.preventDefault();
    event.stopPropagation();
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
    });
  };

  onPaymentMethodCreated = async () => {
    this.setState({
      loading: true,
      entities: [],
    });

    const items = await this.props.fetchEntities();

    this.setState({
      loading: false,
      entities: items,
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.entities !== this.props.entities || prevProps.loading !== this.props.loading) {
      this.setState({
        loading: this.props.loading,
        entities: this.props.entities,
      });
    }
  }

  render() {
    const { config } = this.props;
    const { name, entityName, validation, fields, renderers } = config;
    const { entityError, entityResult, handleCreate, handleEdit, success } = this.props;

    const { handleToggle, handleDelete } = this;
    return (
      <div>
        <EntityList
          loading={this.state.loading}
          entityName={entityName}
          entities={this.state.entities}
          validation={validation}
          renderers={renderers}
          name={name}
          fields={fields}
          onToggle={handleToggle}
          onDelete={handleDelete}
          entityError={entityError}
          entityResult={entityResult}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          allowCreate={false}
          allowDelete={false}
          customEntityToListValuesMapper={customEntityToListValuesMapper}
          currentLocale={config.locale}
          success={success}
        />
        <FormCreateNewPaymentType
          optionsTickerHave={this.state.entities}
          propertyTicker={this.props.property.ticker}
          onNewPayment={this.onPaymentMethodCreated}
        />
        <CreditCardList propertyTicker={this.props.property.ticker} />
      </div>
    );
  }
}

PaymentTypesList.propTypes = {};

PaymentTypesList.defaultProps = {
  entities: [],
};

export default withProperty(PaymentTypesList);
